import React from "react";
import "./CollectionBox.css"; // Make sure your CSS supports these new visuals!
import { Link } from "react-router-dom";

const CollectionBox = ({ locale = "en" }) => { // Add a locale prop
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // --- Text based on locale (simple example, use i18n for real app) ---
  const texts = {
    en: {
      premium: "Eid Festive Collection",
      womens: "Women's",
      womensJewelry: "Traditional Jewelry",
      exploreNow: "Explore Now",
      hotList: "Top Picks",
      mens: "Men's",
      mensJewelry: "Eid Accessories",
      teenagers: "Teenager's",
      teenJewelry: "Trendy Styles",
      egift: "E-Gift",
      egiftCards: "Cards for Eid",
      egiftDesc: "Surprise them with the perfect Eid gift.",
      shopNow: "Shop Now",
    },
    ur: {
      premium: "عید کی تہواری کلیکشن", // Eid ki Tehwaari Collection
      womens: "خواتین کے لیے", // Khawateen ke liye
      womensJewelry: "روایتی زیورات", // Riwayati Zevraat
      exploreNow: "ابھی دیکھیں", // Abhi Dekhein
      hotList: "منتخب کردہ",   // Muntakhab Karda
      mens: "مردوں کے لیے", // Mardon ke liye
      mensJewelry: "عید کے لوازمات", // Eid ke Lawazmaat
      teenagers: "نوجوانوں کے لیے", // Naujawano ke liye
      teenJewelry: "جدید اسٹائلز", // Jadeed Styles
      egift: "ای-گفٹ", // E-Gift
      egiftCards: "عید کے لیے کارڈز", // Eid ke liye Cards
      egiftDesc: "انہیں عید کا بہترین تحفہ دیں۔", // Unhein Eid ka behtareen tohfa dein.
      shopNow: "ابھی خریدیں", // Abhi Khareedein
    }
  };

  const t = texts[locale] || texts.en; // Fallback to English

  return (
    <>
      <div className="collection">
        <div className="collectionLeft eid-women-bg"> {/* Add specific class for background image */}
          <p className="col-p">{t.premium}</p>
          <h3 className="col-h3">
            <span>{t.womens}</span> {t.womensJewelry}
          </h3>
          <div className="col-link">
            <Link to="/shop/eid-collection-women" onClick={scrollToTop}> {/* More specific link */}
              <h5>{t.exploreNow}</h5>
            </Link>
          </div>
        </div>
        <div className="collectionRight">
          <div className="collectionTop eid-men-bg"> {/* Add specific class for background image */}
            <p className="col-p">{t.hotList}</p>
            <h3 className="col-h3">
              <span>{t.mens}</span> {t.mensJewelry}
            </h3>
            <div className="col-link">
              <Link to="/shop/eid-collection-men" onClick={scrollToTop}>
                <h5>{t.exploreNow}</h5>
              </Link>
            </div>
          </div>
          <div className="collectionBottom">
            <div className="box1 eid-teen-bg"> {/* Add specific class for background image */}
              <p className="col-p">{t.hotList}</p>
              <h3 className="col-h3">
                <span>{t.teenagers}</span> {t.teenJewelry}
              </h3>
              <div className="col-link">
                <Link to="/shop/teen-eid-styles" onClick={scrollToTop}>
                  <h5>{t.exploreNow}</h5>
                </Link>
              </div>
            </div>
            <div className="box2 eid-giftcard-bg"> {/* Add specific class for background image */}
              <h3 className="col-h3">
                <span>{t.egift}</span> {t.egiftCards}
              </h3>
              <p className="col-p">{t.egiftDesc}</p>
              <div className="col-link">
                {/* --- THIS IS THE CORRECTED LINE --- */}
                <Link to="/gift-card" onClick={scrollToTop}> {/* Changed from "/gift-cards" */}
                  <h5>{t.shopNow}</h5>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CollectionBox;